import { useMemo } from 'react';
import { inboxTableColumns } from '../../config';
import { InboxFilter, InboxApi } from '../../models';
import { getMeaningfulTags } from '../index';

interface UseInboxColumnsProps {
  inboxes: InboxApi[];
  filter: InboxFilter;
  isLoading: boolean;
}

const useInboxColumns = ({
  inboxes,
  filter,
  isLoading,
}: UseInboxColumnsProps) => {
  const columns = useMemo(() => {
    const hasMeaningfulTags = inboxes.some((item) => {
      const tags = (item as any).tags;
      if (!tags || typeof tags !== 'string' || tags.trim().length === 0) {
        return false;
      }

      if (filter.sector.name === 'CP' || filter.sector.name === 'SA') {
        const tagArray = getMeaningfulTags(tags);
        return tagArray.length > 0;
      }

      return true;
    });

    const hasDocuments = inboxes.some((item) => {
      const doc = (item as any).documentNumber;
      return doc && typeof doc === 'string' && doc.trim().length > 0;
    });

    const hasReason = inboxes.some((item) => {
      const reason = (item as any).reason;
      return reason && typeof reason === 'string' && reason.trim().length > 0;
    });

    const hasLocation = inboxes.some((item) => {
      const loc = (item as any).shippingLocation;
      return loc && typeof loc === 'string' && loc.trim().length > 0;
    });

    let filtered = [...inboxTableColumns];

    if (filter.sector.name === 'SA') {
      filtered = filtered.filter((col) => col.field !== 'documentNumber');
    } else if (!hasDocuments && !isLoading) {
      filtered = filtered.filter((col) => col.field !== 'documentNumber');
    }

    if (filter.sector.name === 'CP') {
      filtered = filtered.filter((col) => col.field !== 'shippingLocation');
    } else if (!hasLocation && !isLoading) {
      filtered = filtered.filter((col) => col.field !== 'shippingLocation');
    }

    if (!hasMeaningfulTags && !isLoading) {
      filtered = filtered.filter((col) => col.field !== 'tags');
    }

    if (!hasReason && !isLoading) {
      filtered = filtered.filter((col) => col.field !== 'reason');
    }
    return filtered;
  }, [filter.sector.name, inboxes, isLoading]);

  return columns;
};

export default useInboxColumns;
